import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Header.css";

export default function Header(props) {
  // To keep items aligned correctly in flexbox, we need to have all three of the containers,
  // even if they're empty.
  return (
    <div className={classNames(styles.spacer, props.className)}>
      <header className={styles.root}>
        <div className={`${styles.left} left`}>{props.left}</div>
        <div className={`${styles.center} center`}>{props.center}</div>
        <div className={`${styles.right} right`}>{props.right}</div>
        {props.children}
      </header>
    </div>
  );
}

Header.propTypes = {
  left: PropTypes.node,
  center: PropTypes.node.isRequired,
  right: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
};
